import { Box, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ShareLinkCommentThread } from "./share-link-comment-thread"

// One calendar-day group in the chat feed: a centered chat-style day separator followed by the
// day's threads. Schedule/viewer/handlers are read from the surrounding <Bound> to avoid
// prop-drilling through <Repeat>. Rendered as a <Repeat> item, so it lives in its own file.
export function ShareLinkCommentDayGroup({ group }) {
    const { schedule, viewer, onReply, onResolve, onEdit, onDelete, onJump, onReveal } = useBoundContext()

    return (
        <Stack spacing={1} data-cy={`share-link-comment-day-${group.key}`}>
            <Box sx={{ display: "flex", justifyContent: "center", py: 0.5 }}>
                <Typography variant="caption" color="text.secondary" data-cy="share-link-comment-day-label">
                    {group.label}
                </Typography>
            </Box>
            <Repeat
                list={group.threads}
                pass="comment"
                item={
                    <ShareLinkCommentThread
                        schedule={schedule}
                        viewer={viewer}
                        onReply={onReply}
                        onResolve={onResolve}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onJump={onJump}
                        onReveal={onReveal}
                    />
                }
            />
        </Stack>
    )
}
